import { BmGroupAction } from "../../../pojo/bm-enums";
import { AbstractControl, FormArray, FormGroup } from "@angular/forms";
import { BmItem } from "../../../pojo/bm-classes";
export class GroupActionHelperService {

  /**
   * Handles a single group action.
   *
   * @param action which BmGroupAction we do (ADD, DELETE, DUPLICATE, RENAME, etc.)
   * @param groupsFA the FormArray containing all group FormGroups
   * @param groupFG the specific group FormGroup to operate on (for DELETE, DUPLICATE, RENAME, etc.)
   * @param createDefaultModelFn function that returns a new default group object
   * @param createFormFn function that, given a model object, returns a new FormGroup
   * @param subscribeFn optional function that subscribes to valueChanges on the newly created group
   * @param groupNamePrefix optional prefix for newly created group names
   */
  public static handleGroupAction<T extends { [K in keyof T]: AbstractControl<any, any>; }>(
    action: BmGroupAction,
    groupsFA: FormArray<FormGroup<T>>,
    groupFG: FormGroup<T> | undefined,
    createDefaultModelFn: (name: string, priority: number) => any,
    createFormFn: (model: any) => FormGroup<T>,
    subscribeFn?: (fg: FormGroup<T>) => void,
    groupNamePrefix = 'New Group'
  ): void {
    if (!groupFG && action !== BmGroupAction.ADD) {
      return;
    }

    switch (action) {

      case BmGroupAction.ADD: {
        const newName = `${groupNamePrefix} ${groupsFA.length + 1}`;
        const newPriority = groupsFA.length;
        const newModel = createDefaultModelFn(newName, newPriority);
        const newFG = createFormFn(newModel);
        groupsFA.push(newFG);
        if (subscribeFn) {
          subscribeFn(newFG);
        }
        break;
      }

      case BmGroupAction.DELETE: {
        const idx = groupsFA.controls.indexOf(groupFG);
        if (idx !== -1) {
          groupsFA.removeAt(idx);
        }
        break;
      }

      case BmGroupAction.DUPLICATE: {
        const oldValue = groupFG.getRawValue();
        // deep clone
        const newValue = structuredClone(oldValue);
        newValue['uuid'] = null;
        newValue['name'] = `${oldValue['name']} (copy)`;
        newValue['priority'] = groupsFA.length;
        // if subGroupData array => set all .uuid = null
        if (newValue['items']) {
          newValue['items'].forEach((item: BmItem) => {
            item.uuid = null;
          });
        }
        if (newValue['subGroups']) {
          newValue['subGroups']['commitment']['items'].forEach((item: BmItem) => {
            item.uuid = null;
          });
          newValue['subGroups']['mgmFeesPcnt']['items'].forEach((item: BmItem) => {
            item.uuid = null;
          });
          newValue['subGroups']['pcntOfMgmFees']['items'].forEach((item: BmItem) => {
            item.uuid = null;
          });
          newValue['subGroups']['vatPcnt']['items'].forEach((item: BmItem) => {
            item.uuid = null;
          });
        }
        // turn into new FormGroup
        const dupFG = createFormFn(newValue);
        groupsFA.push(dupFG);
        if (subscribeFn) {
          subscribeFn(dupFG);
        }
        break;
      }

      case BmGroupAction.RENAME: {
        groupFG.controls['isRenameMode']?.patchValue(true);
        groupFG.controls['oldName']?.patchValue(groupFG.controls['name'].value);
        break;
      }

      case BmGroupAction.RENAME_SAVE: {
        groupFG.controls['isRenameMode']?.patchValue(false);
        groupFG.controls['oldName']?.patchValue(groupFG.controls['name'].value);
        break;
      }

      case BmGroupAction.RENAME_CANCEL: {
        const oldName = groupFG.controls['oldName']?.value;
        groupFG.controls['name']?.patchValue(oldName);
        groupFG.controls['isRenameMode']?.patchValue(false);
        break;
      }
    }
  }
}

